import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Web Core Design System tokens
 */
export var fonts = {
  primary: 'var(--wcds-font-primary)',
  secondary: 'var(--wcds-font-secondary)',
  arabic: 'var(--wcds-font-arabic)',
  japanese: 'var(--wcds-font-japanese)'
};
export default _objectSpread(_objectSpread({}, fonts), {}, {
  /**
   * @deprecated - use `secondary` instead
   */
  formular: fonts.secondary,

  /**
   * @deprecated - use `primary` instead
   */
  spoof: fonts.primary,

  /**
   * @deprecated - use `japanese` instead
   */
  mPlus1: fonts.japanese,

  /**
   * @deprecated - use `arabic` instead
   */
  vazirmatn: fonts.arabic
});